import { ethers } from 'ethers';
import { CHAIN_NAMESPACES, getEvmChainConfig, UX_MODE, WEB3AUTH_NETWORK } from '@web3auth/base';
import  lighthouse  from '@lighthouse-web3/sdk';
import { AuthAdapter } from "@web3auth/auth-adapter";
import { availableNetworks } from "../config/availableNetworks";
import { Web3AuthNoModal } from "@web3auth/no-modal";
import { WALLET_ADAPTERS } from "@web3auth/base";
import store from "../../store/store";
import { chainAC, providerAC } from "../../store/action-creators";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import { baseUrl } from "../config/urls";
import { getAccessToken, getLoginType } from "./auth";
import axios from "axios";
import { validateEmail } from './emailService';
import { changeAddNetworkMetamask, checkMetamaskCurrentChain } from './evm';
import { clearStore } from '../../store/StoreService';

const clientId = process.env.REACT_APP_WEB3AUTH_APP_ID || "";
const brevo_key = process.env.REACT_APP_BREVO_ID || "";

export var web3auth: any = undefined;


export const getInitChain = async () => {
  let chain = null;
  if ((window as any).ethereum) {
    chain = await checkMetamaskCurrentChain();
  } else {
    chain = store?.getState()?.["currentChain"]?.["currentChain"];
  }
  return chain ? chain : "fvm";
};

export const initWeb3Auth = async () => {
  try {
    const initChain = getWeb3AuthChainConfig(await getInitChain());
    const chainConfig = getEvmChainConfig(0xaa36a7, initChain.chainId)!;

    const privateKeyProvider = new EthereumPrivateKeyProvider({ config: { chainConfig } });
 
    web3auth = new Web3AuthNoModal({
    clientId: clientId,
    web3AuthNetwork:WEB3AUTH_NETWORK.MAINNET,
    privateKeyProvider
  });
    // const openloginAdapter = new OpenloginAdapter({
    //   privateKeyProvider,
    //   adapterSettings: {
    //     sessionTime: 86400,
    //     uxMode: UX_MODE.POPUP,
    //   },
    // });
    const authadapter = new AuthAdapter();

    web3auth.configureAdapter(authadapter);
    await web3auth.init();
    // await web3auth?.addChain(initChain);
    if (web3auth.provider) {
      await store.dispatch(providerAC.setProvider({ web3authProvider: web3auth?.provider }));
    }
  } catch (error) {
    console.error(error, "Error Initiating WEB3AUTH");
  }
};

export const web3authLogout = async () => {
  if (web3auth?.connected) {
    await web3auth.logout();
  } else {
    return;
  }
};

export const getWeb3AuthChainConfig = (chainName: string) => {
  let chainData = availableNetworks[chainName];
  //
  if (chainData) {
    let chainConfig = {
      chainNamespace: CHAIN_NAMESPACES.EIP155,
      chainId: chainData.chainId,
      rpcTarget: chainData.rpcUrls,
      displayName: chainData.chainName,
      blockExplorer: chainData.blockExplorerUrls,
      ticker: chainData?.nativeCurrency?.symbol,
      tickerName: chainData?.nativeCurrency?.name,
    };
    return chainConfig;
  } else {
    throw new Error(`Chain name ${chainName} not found in available networks`);
  }
};

export const changeWeb3AuthChain = async (chainName: string) => {
  try {
    let chainConfig = getWeb3AuthChainConfig(chainName);
    let loginType = getLoginType();
    if (loginType === "openlogin") {
      await web3auth?.addChain(chainConfig);
      await web3auth?.switchChain(chainConfig);
    } else {
      await changeAddNetworkMetamask(chainName);
    }
    await store.dispatch(chainAC.setCurrentChain({ currentChain: chainName }));
    return true;
  } catch (error) {
    //
    return false;
  }
};



export const web3AuthLogin = async (loginProvider: any, login_hint:string) => {
  try {
    let web3authProvider = null;
    web3authProvider = await web3auth.connectTo(WALLET_ADAPTERS.AUTH, {
      loginProvider,
      extraLoginOptions: {
        login_hint: login_hint ? login_hint : "",
      },
    });
    await store.dispatch(providerAC.setProvider({ web3authProvider }));
  } catch (error) {
    // console.log(error)
    clearStore();
    console.error(`Error:${error}`);
    return;
  }
};



export const sign_message_web3auth = async (): Promise<{
  message: string;
  signed_message: string;
  address: string;
  alternativeAddress:string
} | void> => {
  try {
    const web3authProvider = store?.getState()?.["currentProvider"]['web3authProvider'];
    const provider = new ethers.BrowserProvider(web3authProvider)
    const signer = await provider.getSigner();
    //
    const address = await signer.getAddress();
    //
    const res = await axios.get(
      `${baseUrl}/api/auth/get_message?publicKey=${address}&encryption=true`
    );
    const message = res.data;
    const signed_message =  await signer.signMessage(message);

    //

    return {
      message: message,
      signed_message: await signed_message,
      address: address,
      alternativeAddress: address
    };
  } catch (error) {
    console.error("Error signing message with Web3Auth:", error);
  }
};

export const sign_auth_message_web3auth = async (): Promise<any> => {
  const web3authProvider = store?.getState()?.["currentProvider"]['web3authProvider'];
  const provider = new ethers.BrowserProvider(web3authProvider)
  const signer = await provider.getSigner();
  const address = await signer.getAddress();
  const messageRequested = await lighthouse.getAuthMessage(address);


  const signed_message = await signer.signMessage(
    messageRequested?.data?.message || ''
  );
  //

  return await signed_message;
};

export const verifyWeb3authEmail = async () => {
  try {
    const user = await web3auth?.getUserInfo();

    if (user?.email && validateEmail(user?.email)) {
      await axios.get(
        `${baseUrl}/api/user/verify_web3auth_email?appPubKey=${"app_pub_key"}&idToken=${user?.idToken
        }&email=${user?.email}`,
        {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
        }
      );
    }
  } catch (error) {
    console.error(error, "ERROR in the verifyWeb3authEmail");
  }
};



export const addEmailToBrevo = async () => {
  try {
    const user = await web3auth?.getUserInfo();
    if (user?.email && validateEmail(user?.email)) {
      const options = {
        method: "POST",
        url: "https://api.brevo.com/v3/contacts",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          "api-key": brevo_key,
        },
        data: {
          updateEnabled: false,
          email: user.email,
          ext_id: `filesdapp-web3auth-${user.email}`,
          listIds: [7],
        },
      };

      axios
        .request(options)
        .then(function (response) {
          //
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  } catch (error) {
    //
  }
};


